module.exports = __webpack_public_path__ + "/login_ui/img/pr-d243c1973db6408ec83edb0dd9bb08c0.svg";